const ThrowStatement = {
  print: () => 'throw;'
};

module.exports = ThrowStatement;
